import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            // Una sesión caducada solo expulsa de las pantallas que de verdad
            // la exigen. En el catálogo, el carrito o el checkout (que
            // funcionan sin cuenta) se descarta el token y se sigue como invitado.
            const exigeSesion = /^\/(pedidos|pedido\/|admin)/.test(window.location.pathname);
            if (exigeSesion) window.location.href = '/auth';
        }
        return Promise.reject(error);
    }
);

// Auth
export const authAPI = {
    register: (data) => api.post('/auth/register', data),
    login: (data) => api.post('/auth/login', data),
    me: () => api.get('/auth/me'),
    forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
    resetPassword: (token, new_password) => api.post('/auth/reset-password', { token, new_password }),
};

// Products
export const productsAPI = {
    getAll: () => api.get('/products'),
    getOne: (id) => api.get(`/products/${id}`),
};

// Cart
export const cartAPI = {
    get: () => api.get('/cart'),
    add: (data) => api.post('/cart', data),
    update: (id, data) => api.put(`/cart/${id}`, data),
    remove: (id) => api.delete(`/cart/${id}`),
};

// Orders
export const ordersAPI = {
    getAll: () => api.get('/orders'),
    getOne: (id) => api.get(`/orders/${id}`),
};

// Tracking
export const trackingAPI = {
    track: (number) => api.get(`/tracking/${number}`),
};

// Admin
export const adminAPI = {
    stats: () => api.get('/admin/stats'),
    orders: () => api.get('/admin/orders'),
    updateOrderStatus: (id, data) => api.put(`/admin/orders/${id}/status`, data),
    products: () => api.get('/admin/products'),
    createProduct: (data) => api.post('/admin/products', data),
    updateProduct: (id, data) => api.put(`/admin/products/${id}`, data),
    deleteProduct: (id) => api.delete(`/admin/products/${id}`),
};

// Seed
export const seedAPI = {
    seed: () => api.post('/seed'),
};

export default api;
